
import Index from "@/views/Index/index"
import Risk from "@/views/Risk/riskIndex";
import RiskQdsj from "@/views/Risk/riskQdsj"
import RiskHgsj from "@/views/Risk/riskHgsj"
import RiskGyssj from "@/views/Risk/riskGyssj"
import RiskXxdc from "@/views/Risk/riskXxdc"
//
import Advisory from "@/views/Advisory/advisoryIndex"
import AdvisoryZjgwtjj from "@/views/Advisory/advisoryZjgwtjj"
//信息技术
import Information from "@/views/Information/informationIndex";
import dynamics from "@/views/Information/dynamics";
import observation from "@/views/Information/observation";

import informationDetail from "@/views/Information/informationDetail";
import InformationYssjk from "@/views/Information/informationYssjk";
import InformationBi from "@/views/Information/informationBi";
import InformationJjjspt from "@/views/Information/informationJjjspt";
import InformationIpad from "@/views/Information/informationIpad";
//关于我们
import About from "@/views/About/aboutIndex";
import AboutQyjg from "@/views/About/aboutQyjg";
import AboutHwkh from "@/views/About/aboutHwkh";
import AboutWmdyj from "@/views/About/aboutWmdyj";
import AboutWmdjzg from "@/views/About/aboutWmdjzg";
import AboutLxwm from "@/views/About/aboutLxwm";
//友情链接
import Link from "@/views/Link/linkIndex"
//联系我们
import Contact from "@/views/Contact/contactIndex"
import Join from "@/views/Contact/joinIndex"
//渠道风险控制
import ChannelManager from "@/views/Advisory/ChannelIndex";
import ComplianceManager from "@/views/Advisory/ComplianceIndex";
import ConsultationManager from "@/views/Advisory/ConsultationIndex";

export default [
    {
        path: '/',
        name: '北京康柏汉森医药科技咨询有限责任公司',
        component: Index
    },
    {
        path: '/home',
        name: '北京康柏汉森医药科技咨询有限责任公司',
        component: Index
    },
    {
        path: '/Risk',
        name: '北京康柏汉森医药科技咨询有限责任公司',
        //component: Risk
        component: Advisory,
    },
    {
        path: '/RiskQdsj',
        name: '北京康柏汉森医药科技咨询有限责任公司-渠道风控',
        //component: RiskQdsj
        component: Advisory,
    },
    {
        path: '/hgsj',
        name: '北京康柏汉森医药科技咨询有限责任公司-合规风控',
        //component: RiskHgsj
        component: ComplianceManager,
    },
    {
        path: '/gyssj',
        name: '北京康柏汉森医药科技咨询有限责任公司-企业健康咨询',
        //component: RiskGyssj
        component: ConsultationManager,
    },
    {
        path: '/xxdc',
        name: '北京康柏汉森医药科技咨询有限责任公司-信息调查',
        //component: RiskXxdc
        component: Advisory,
    },
    {
        path: '/Advisory',
        name: '北京康柏汉森医药科技咨询有限责任公司-管理咨询简介',
        component: Advisory,
        children:[]
    },{
        path: '/compliance',
        name: '北京康柏汉森医药科技咨询有限责任公司-合规风险控制',
        component: ComplianceManager,
        children:[]
    },
    {
        path: '/consultation',
        name: '北京康柏汉森医药科技咨询有限责任公司-企业健康咨询',
        component: ConsultationManager,
        children:[]
    },
    {
        path: '/zjgwtjj',
        name: '北京康柏汉森医药科技咨询有限责任公司-专家顾问团简介',
        //component: AdvisoryZjgwtjj,
        component: Advisory,
        children:[]
    },
    //
    {
        path: '/Information',
        name: '北京康柏汉森医药科技咨询有限责任公司-新闻中心',
        component: Information,
        children:[]
    },{
        path: '/dynamics',
        name: '北京康柏汉森医药科技咨询有限责任公司-康柏动态',
        component: dynamics,
        children:[]
    },
    {
        path: '/observation',
        name: '北京康柏汉森医药科技咨询有限责任公司-行业观察',
        component: observation,
        children:[]
    }
    ,{
        path: '/news',
        name: '北京康柏汉森医药科技咨询有限责任公司-新闻详情',
        component: informationDetail,
        children:[]
    }
    ,{
        path: '/yssjk',
        name: '北京康柏汉森医药科技咨询有限责任公司-医生数据库查询管理平台',
        //component: InformationYssjk,
        component: Index,
        children:[]
    },{
        path: '/bi',
        name: '北京康柏汉森医药科技咨询有限责任公司-BI数据整合平台',
        //component: InformationBi,
        component: Index,
        children:[]
    },{
        path: '/jjjspt',
        name: '北京康柏汉森医药科技咨询有限责任公司-奖金计算平台',
        //component: InformationJjjspt,
        component: Advisory,
        children:[]
    },{
        path: '/ipad',
        name: '北京康柏汉森医药科技咨询有限责任公司-IPAD数据采集平台',
        //component: InformationIpad,
        component: Index,
        children:[]
    }

    ,{
        path: '/Outsourcing',
        name: '北京康柏汉森医药科技咨询有限责任公司-新闻中心',
        //component: News,
        component: Information,
        children:[]
    }
    ,{
        path: '/Outsourcing_info',
        name: '北京康柏汉森医药科技咨询有限责任公司-新闻中心',
        //component: NewsInfo,
        component: Information,
        children:[]
    }


    //
    ,{
        path: '/about',
        name: '北京康柏汉森医药科技咨询有限责任公司-关于我们',
        component: About,
        children:[]
    },
    {
        path: '/gywm',
        name: '北京康柏汉森医药科技咨询有限责任公司-about',
        component: About,
        children:[]
    },
    {
        path: '/qyjg',
        name: '北京康柏汉森医药科技咨询有限责任公司-企业架构',
        //component: AboutQyjg,
        component: Index,
        children:[]
    }
    ,{
        path: '/hwkh',
        name: '北京康柏汉森医药科技咨询有限责任公司-服务客户',
        //component: AboutHwkh,
        component: About,
        children:[]
    },{
        path: '/wmdyj',
        name: '北京康柏汉森医药科技咨询有限责任公司-我们的愿景',
        //component: AboutWmdyj,
        component: Index,
        children:[]
    },
    {
        path: '/wmdjzg',
        name: '北京康柏汉森医药科技咨询有限责任公司-我们的价值观',
        //component: AboutWmdjzg,
        component: Index,
        children:[]
    },
    {
        path: '/lxwm',
        name: '北京康柏汉森医药科技咨询有限责任公司-联系我们',
        //component: AboutLxwm,
        component: Contact,
        children:[]
    },
    {
        path: '/link',
        name: '北京康柏汉森医药科技咨询有限责任公司-友情链接',
        //component: Link,
        component: Join,
        children:[]
    },
    {
        path: '/contact',
        name: '北京康柏汉森医药科技咨询有限责任公司-联系我们',
        component: Contact,
        children:[]
    },
    {
        path: '/join',
        name: '北京康柏汉森医药科技咨询有限责任公司-加入我们',
        component: Join,
        children:[]
    },

]
